window.Sanitas = window.Sanitas || {}
window.Sanitas.Tracking = window.Sanitas.Tracking || {}

const root = window.Sanitas.Tracking

export default root
